"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resultStyles = void 0;
const lit_1 = require("lit");
exports.resultStyles = (0, lit_1.css) `
  :host {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: var(--layout-width-narrow);
    gap: var(--space-4);
    margin: 0 auto;
  }

  ::slotted(*) {
    width: 100%;
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0LnN0eWxlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInJlc3VsdC5zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsNkJBQXlCO0FBRVosUUFBQSxZQUFZLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7Ozs7Ozs7O0NBYzlCLENBQUEifQ==